import {Component, Inject, inject, HostListener } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DOCUMENT, LocationStrategy} from '@angular/common';
import CustomerLeadsModel from 'src/app/services/customerPond.model';
import { CustomerLeadService } from 'src/app/services/customerLead.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { PersonsService } from 'src/app/services/persons.service';
import PersonsModel from 'src/app/services/persons.model';
import { BusinessEntityService } from 'src/app/services/businessEntity.service';
import { FarmSiteService } from 'src/app/services/farmSite.service';
import BusinessEntity from 'src/app/services/businessEntity.model';
import { ExcelService } from 'src/app/services/excelService';
import { CountriesService } from 'src/app/countries.service';
import { PreviousRouteService } from 'src/app/services/previousRouteService';
import CreditsManagersModel from 'src/app/services/creditsManagers.model';
import { CreditsManagersService } from 'src/app/services/creditsManagers.service';
import { BluEyeStatsService } from 'src/app/services/bluEyeStats.service';
import { LeadsExcelObj } from 'src/app/services/customerLead.model';
import { BatchLoader } from 'src/app/Utils/batch-loader.util';
import { ToastrService } from 'ngx-toastr';

declare var $: any;
@Component({
  selector: 'app-blu-eye',
  templateUrl: './blu-eye.component.html',
  styleUrls: ['./blu-eye.component.css']
})
export class BluEyeComponent {
    public customerLeads: Array<CustomerLeadsModel>;
    public leadsExcelObj: LeadsExcelObj;
    public loginPersonType: string;
    public LoginUserName: string;
    public loginUserBusinessName: string;    
    public dataLoader: boolean;
    public showBluEyeSubscriberDetails: boolean;
    public showBuyersDetails: boolean;
  
    public weekfromDate: string;
    public monthfromDate: string;
    public yearfromDate: string;
    public todayDate: string;
    public noOfDays: string;
    public tablenoOfDays: string;
    public finalData: any [];
    public bluEyeSearch: string;
    public followupForm: FormGroup;
    public customerLead: CustomerLeadsModel;
    public currentDate: string;
    /*close*/
    public closeForm: FormGroup;
    /*assign*/
    public persons: Array<PersonsModel>;
    public person: PersonsModel;
    public assignedForm: FormGroup;
    public businessEntity: BusinessEntity;
    public yesterDayDate: string;
    public lastMonthEndDate: string;
    public lastMonthStartDate: string;
    public lastWeekDate: string;
    public lastYearEndDate: string;
    public lastYearStartDate: string;
    public clearBluEyeSearchInput: boolean;
    public countries: any;
    public responseLoader: boolean;
    customFromDate: string;
    customToDate: string;
    public isDateRangePopupOpen: boolean = false;
    customBluEyeFromDate: string;
    customBluEyeToDate: string;
    public isBluEyeDateRangePopupOpen: boolean = false;
    customMCFromDate: string;
    customMCToDate: string;
    customMCREPFromDate: string;
    customMCREPToDate: string;
    isMCREPDateRangePopupOpen: boolean = false;
    customFarmsFromDate: string;
    customFarmsToDate: string;
    isFarmsDateRangePopupOpen: boolean = false;
    customBuyerFromDate: string;
    customBuyerToDate: string;
    isBuyerDateRangePopupOpen: boolean = false;
    public bluEyeSubscribersList: CreditsManagersModel[] = [];
    public filteredBluEyeSubscribers: CreditsManagersModel[] = [];
    public bluEyeSubscribers: CreditsManagersModel[] = [];
    public filterBluEyeSubscribers: CreditsManagersModel[] = [];
    public statusFilter: boolean = false;
    public status: string = '';
    public businessOnboarded: number = 0;
    public devices: number = 0;
    public snapsCount: number = 0;
    public totalValue: number = 0;
    public formattedTotalValue: any;
    public bluEyeStatsObjectsByDateCpy: Array<any> = [];
    public bluEyeStatsObjectsByDate: Array<any> = [];
    public listLoader = false;              // Show listLoader spinner
    public isFiltering: boolean = false;
    public noList: boolean = false;
    private batchLoader: BatchLoader<any>; 

    public creditsManagersService = inject(CreditsManagersService);
    public bluEyeStatsService = inject(BluEyeStatsService)

    /**
      * Constructor of the component.
      *
      * @param {any} document - The global document object.
      * @param {ExcelService} excelService - The service for Excel functionality.
      * @param {FarmSiteService} farmsiteService - The service for farm site data.
      * @param {BusinessEntityService} businessEntityService - The service for business entities.
      * @param {PersonsService} personsService - The service for person data.
      * @param {ActivatedRoute} route - The current route information.
      * @param {FormBuilder} formBuilder - The FormBuilder for creating forms.
      * @param {MarketConnectService} marketConnectService - The service for market connect data.
      * @param {CustomerLeadService} customerLeadService - The service for customer leads.
      */
    constructor(@Inject(DOCUMENT) private document: any, public countryService: CountriesService, public excelService: ExcelService, public farmsiteService: FarmSiteService, public businessEntityService: BusinessEntityService, public personsService: PersonsService, public route: ActivatedRoute, public formBuilder: FormBuilder, public customerLeadService: CustomerLeadService,
    private locationStrategy: LocationStrategy, private previousRouteService: PreviousRouteService, public toastr: ToastrService) {
      /**
       * Initializing a new customer lead  model.
       * This will be used to store the data for the current customer lead.
       */
      this.customerLead = new CustomerLeadsModel();
      /**
        * Initializing lead followup for validation.
        * This FormGroup represents the form controls for the lead followup.
        * @type {FormGroup}
        * @type {FormControl}
        */
      this.followupForm = this.formBuilder.group({
        description: ['', [Validators.required,
          Validators.minLength(3),
          Validators.maxLength(200)]]
      });
      /**
        * Initializing close form for validation.
        * This FormGroup represents the form controls for the close lead.
        * @type {FormGroup}
        * @type {FormControl}
        */
      this.closeForm = this.formBuilder.group({
        convert: [null],
        closedescription: ['', [Validators.required,
          Validators.minLength(3),
          Validators.maxLength(200)]]
      });
      /**
        * Initializing assign form for validation.
        * This FormGroup represents the form controls for the assign person.
        * @type {FormGroup}
        * @type {FormControl}
        */
      this.assignedForm = this.formBuilder.group({
        businessid: ['', [Validators.required]]
      });
    }

    /**
      * @async
      * @method
      * @throws {Error} If there's an error during initialization.
      * @returns {Promise<void>} A Promise that resolves when the initialization is completed or rejects if an error occurs.
      * Description:
      * 1. When the page loads, this function is triggered.
      * 2. It prepares the page and loads market connects, businesses data by calling getMarketConnectCountsByDate and getAllBusinessEntity methods
      * which is in the {@link MarketConnectService} and {@link BusinessEntityService} file.
      */
    public async ngOnInit(): Promise<void> {
      try {
        window.scrollTo(0, 0);
        this.bluEyeSubscribersList = [];
        this.loginPersonType = localStorage.getItem('loginPersonType');
        this.LoginUserName = localStorage.getItem('LoginUserName');
        this.loginUserBusinessName = localStorage.getItem('loginBusinessName');
        this.previousRouteService.setPreviousRoute(this.locationStrategy.path()); // To store the Previous route
        /* user login details end */
        this.showBuyersDetails = false;
        this.responseLoader = false;
        this.initDates();
        this.customFromDate = '';
        this.customToDate = '';
        this.noOfDays = 'today';
        this.statsDays('today');
      } catch (error) {
        this.toastr.error(error.error?.message || error)
      }
    }

    /**
      * @method
      * @param {string} val - The selected time range ('today', 'oneweek', 'onemonth', 'oneyear').
      * @returns {void} This function does not return a value.
      * Description:
      * This method is used to Updates the hatchery table data based on the selected time range.
      */
    public statsDays(val: string): void {
      this.noOfDays = val;
      // Store previous selection before changing
      if (val !== 'Custom') {
        this.previousBluEyeTableDays = val;
      }
      this.noOfDays = val;
      // Reset custom date values when selecting predefined ranges
      if (val !== 'Custom') {
        this.customFromDate = '';
        this.customToDate = '';
      }
      // If 'Custom' is selected, open the date range popup
      if (val === 'Custom') {
        this.isDateRangePopupOpen = true;
      } else {
        this.statsDateWiseData(val);
      }
    }

    public async statsDateWiseData(type: string) {
      this.businessOnboarded = 0;
      this.snapsCount = 0;
      this.devices = 0;
      this.totalValue = 0;
      this.bluEyeStatsObjectsByDateCpy = [];

      let toDate = moment(new Date()).format('YYYY-MM-DD').toString();
      try {
        if (type === 'today') {
          this.bluEyeStatsObjectsByDateCpy = await this.bluEyeStatsService.getBlueyedayStats(this.todayDate, toDate);
        } else if (type === 'oneweek') {
          this.bluEyeStatsObjectsByDateCpy = await this.bluEyeStatsService.getBlueyedayStats(this.weekfromDate, toDate);
        } else if (type === 'onemonth') {
          this.bluEyeStatsObjectsByDateCpy = await this.bluEyeStatsService.getBlueyedayStats(this.monthfromDate, toDate);
        } else if (type === 'oneyear') {
          this.bluEyeStatsObjectsByDateCpy = await this.bluEyeStatsService.getBlueyedayStats(this.yearfromDate, toDate);
        }
        if (this.bluEyeStatsObjectsByDateCpy) {
          this.sumUpAllStatsDataBySelectedDate(this.bluEyeStatsObjectsByDateCpy);
        }
      } catch (error) {
        this.toastr.error(error.error?.message || error)
      }
    }

    public sumUpAllStatsDataBySelectedDate(statsData: any): void {
      statsData.forEach(item => {
        this.businessOnboarded += item.businesses || 0;
        this.devices += item.devices || 0;
        this.snapsCount += item.snaps || 0;
        this.totalValue += item.value || 0;
      });

      // Limit totalValue to 2 decimal places
      this.totalValue = parseFloat(this.totalValue.toFixed(2));
      this.formattedTotalValue = this.totalValue.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

    }

    public closeDateRangePopup() {
      this.isDateRangePopupOpen = false;
    }

    public async onDateRangeApply(event: { fromDate: string; toDate: string }) {
      this.businessOnboarded = 0;
      this.snapsCount = 0;
      this.devices = 0;
      this.totalValue = 0;
      this.bluEyeStatsObjectsByDateCpy = [];
      // Step 1: Get selected date range
      this.customFromDate = event.fromDate;
      this.customToDate = event.toDate;
      // Step 2: Convert to YYYY-MM-DD format
      let fromDateFormatted = moment(this.customFromDate).format('YYYY-MM-DD');
      let toDateFormatted = moment(this.customToDate).format('YYYY-MM-DD');

      try {
        this.bluEyeStatsObjectsByDateCpy = await this.bluEyeStatsService.getBlueyedayStats(fromDateFormatted, toDateFormatted);
        if (this.bluEyeStatsObjectsByDateCpy) {
          this.sumUpAllStatsDataBySelectedDate(this.bluEyeStatsObjectsByDateCpy);
        }
      } catch(error) {
        this.toastr.error(error.error?.message || error)
      }

      // Close popup after selection
      this.isDateRangePopupOpen = false;
    }
    public async getBluEyeSubscribers() {
      try {
        this.dataLoader = true;
        this.isFiltering = false;
        const subscribersList = await this.creditsManagersService.getAllCreditManagers();
        if (subscribersList?.length > 0) {
          this.bluEyeSubscribers = subscribersList.filter((businessSubcribers) => businessSubcribers.policyDetails?.name == 'BluEye Launch Plan' &&
        ['Farm'].includes(businessSubcribers.businessID?.businessType?.[0]?.name));
        }
        this.customBluEyeFromDate = '';
        this.customBluEyeToDate = '';
        this.status = undefined;
        this.statusFilter = false;
        this.bluEyeSearch = '';
        this.tableDays('today');
      } catch(error) {
        this.toastr.error(error.error?.message || error)
      } finally {
        this.dataLoader = false;
        this.showBluEyeSubscriberDetails = true;
      }
    }

    /**
      * @method
      * @param {string} val - The selected time range ('today', 'oneweek', 'onemonth', 'oneyear').
      * @returns {void} This function does not return a value.
      * Description:
      * This method is used to Updates the hatchery table data based on the selected time range.
      */
    previousBluEyeTableDays: any;
    public tableDays(val: string): void {
      this.filteredBluEyeSubscribers = [];
      this.bluEyeSubscribersList = [];
      this.isFiltering = false;
      this.status = undefined;
      this.statusFilter = false;
    
      this.tablenoOfDays = val;
      this.clearBluEyeSearchInput = false;
      this.bluEyeSearch = '';
      // Store previous selection before changing
      if (val !== 'Custom') {
        this.previousBluEyeTableDays = val;
      }
      this.tablenoOfDays = val;
      // Reset custom date values when selecting predefined ranges
      if (val !== 'Custom') {
        this.customBluEyeFromDate = '';
        this.customBluEyeToDate = '';
      }
      // If 'Custom' is selected, open the date range popup
      if (val === 'Custom') {
        this.isBluEyeDateRangePopupOpen = true;
      } else {
        this.tablegetData(val);
      }
    }

    /**
      * @method
      * @param {string} type - The type of time range ('today', 'oneweek', 'onemonth', 'oneyear').
      * @returns {void} This function does not return a value.
      * Description:
      * This method is used to Retrieves and filters data for the hatchery table based on the selected time range.
      */
    public async tablegetData(type: string) {
      this.filterBluEyeSubscribers = [];
      let toDate = (moment(new Date()).format('YYYY-MM-DD')).toString();
      if (type == 'today') {
        let startDate = new Date(this.todayDate);
        let endDate = new Date(toDate);
        this.filteredBluEyeSubscribers = this.bluEyeSubscribers.filter(a => {
          if (a.createdAt != null) {
            let date = new Date(String(a.createdAt).split('T')[0]);
            return (date >= startDate && date <= endDate);
          }
        });
      } else if (type == 'oneweek') {
        let startDate = new Date(this.weekfromDate);
        let endDate = new Date(toDate);
        this.filteredBluEyeSubscribers = this.bluEyeSubscribers.filter(a => {
          if (a.createdAt != null) {
            let date = new Date(String(a.createdAt).split('T')[0]);
            return (date >= startDate && date <= endDate);
          }
        });
      } else if (type == 'onemonth') {
        let startDate = new Date(this.monthfromDate);
        let endDate = new Date(toDate);
        this.filteredBluEyeSubscribers = this.bluEyeSubscribers.filter(a => {
          if (a.createdAt != null) {
            let date = new Date(String(a.createdAt).split('T')[0]);
            return (date >= startDate && date <= endDate);
          }
        });
      } else if (type == 'oneyear') {
        let startDate = new Date(this.yearfromDate);
        let endDate = new Date(toDate);
        this.filteredBluEyeSubscribers = this.bluEyeSubscribers.filter(a => {
          if (a.createdAt != null) {
            let date = new Date(String(a.createdAt).split('T')[0]);
            return (date >= startDate && date <= endDate);
          }
        });
      }
      this.isFiltering = false;
      this.initializeBatchLoader(); // Reset instance
      this.batchLoader?.reset();     // Clear state
      await this.batchLoader?.loadNextBatch(true); // Load first batch
    }

    public closeBluEyeDateRangePopup() {
      this.isBluEyeDateRangePopupOpen = false;
      // Revert back to last selected option if no custom dates are applied
      if (!this.customBluEyeFromDate || !this.customBluEyeToDate) {
        this.tablenoOfDays = this.previousBluEyeTableDays;
        this.tablegetData(this.tablenoOfDays);
      } else {
        this.onBluEyeDateRangeApply({
          fromDate: this.customBluEyeFromDate,
          toDate: this.customBluEyeToDate
        });
      }
    }

    public onBluEyeDateRangeApply(event: { fromDate: string; toDate: string }) {
      this.filteredBluEyeSubscribers = [];
      this.bluEyeSubscribersList = [];

      this.customBluEyeFromDate = event.fromDate;
      this.customBluEyeToDate = event.toDate;

      let startDate = new Date(this.customBluEyeFromDate);
      let endDate = new Date(this.customBluEyeToDate);

      // Ensure time is set correctly for accurate filtering
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);

      // Filter data within the custom date range safely
      this.filteredBluEyeSubscribers = this.bluEyeSubscribers.filter(a => {
        if (!a.subscriptionStartDate) return false;  //Handle null or undefined dates safely

        let dateStr = String(a.createdAt).split('T')[0];  // Extract only the date part
        let date = new Date(dateStr);
        date.setHours(0, 0, 0, 0);
        return date >= startDate && date <= endDate;
      });

      //  Close popup after selection
      this.isBluEyeDateRangePopupOpen = false;
    }

  @HostListener('window:scroll', [])
  onScroll(): void {
    this.checkScrollAndLoad();
  }
  
  private scrollTimeout: any;
  private checkScrollAndLoad(): void {
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 200 && !this.batchLoader?.isLoading()
      && !this.isFiltering) {
        this.batchLoader?.loadNextBatch();
      }
    }, 50);

  }
  
  private initializeBatchLoader(): void {
    this.batchLoader = new BatchLoader<any>(
      () => this.filteredBluEyeSubscribers,
      (updatedList) => {
        this.bluEyeSubscribersList = updatedList;
        this.noList = updatedList.length === 0;
      },
      undefined, // <-- omit or pass undefined
      (loading) => this.listLoader = loading
    );
  }

    public onFiltersApplied() {
      this.isFiltering = true;
      this.bluEyeSubscribersList = [];
      const value = this.bluEyeSearch && this.bluEyeSearch.replace(/[-_ :.]/g, '').toLowerCase();
      if (this.bluEyeSearch != '') {
        if (this.statusFilter) {
          this.applySearchWithFilterType(value);
        } else {
          this.applySearchFilter(value);
        }
      } else {
        if (this.statusFilter) {
          this.applySearchWithFilterType(value);
        } else {
          this.isFiltering = false;
          this.initializeBatchLoader();
          this.batchLoader?.reset();
          this.batchLoader?.loadNextBatch(true);
          // this.tablegetData(this.tablenoOfDays);
        }
      }
    }
      /**
    * @method
    * @param {string} searchValue - This param is used to get the search value entered by the user manually.
    * Description:
    * This method will be called when user searches the specific data in the search field to filter the subscribers list based upon the search.
    */
    private applySearchFilter(searchValue: string) {
      // this.tablegetData(this.tablenoOfDays);
      this.bluEyeSubscribersList = this.filteredBluEyeSubscribers.filter((subscriber: any) =>
        ['businessName', 'personName', 'paymentDetails.paidFor'].some(property => {
          const nestedPropertyValue = property.split('.').reduce((acc, current) => acc && acc[current], subscriber);
          return nestedPropertyValue && nestedPropertyValue.replace(/[-_ :.]/g, '').toLowerCase().startsWith(searchValue);
        })
      );
    }
    /**
    * @method
    * @param {string} searchValue - This param is used to get the search value entered by the user manually.
    * Description:
    * This method will be called when user searches the specific data and then apply the business type filter upon the filtered data to filter
    * the specific data in two way connection.
    */
    private applySearchWithFilterType(searchValue: string) {
      // this.tablegetData(this.tablenoOfDays);
      this.bluEyeSubscribersList = this.filteredBluEyeSubscribers.filter((subscriber: any) => {
        let includeConditions = true; // Initialize shouldKeep as true
        if (this.statusFilter && String(subscriber.isExpired) != this.status) {
          includeConditions = false;
        }
        const includesSearch = ['businessName', 'personName', 'paymentDetails.paidFor'].some(property => {
          const nestedPropertyValue = property.split('.').reduce((acc, current) => acc && acc[current], subscriber);
          return nestedPropertyValue && nestedPropertyValue.replace(/[-_ :.]/g, '').toLowerCase().startsWith(searchValue);
          })
        return this.bluEyeSearch != '' ? includeConditions && includesSearch : includeConditions;
      });

    }
    /**
      * @method
      * @returns {void} This function does not return a value.
      * Description:
      * This function cancels any ongoing HTTP requests made by the marketConnectService, businessEntityService and customerLeadService
      * when the component is being destroyed, preventing potential memory leaks or unexpected behavior.
      * This can be achieved by calling cancelOnGoingHttpRequests method which is in the {@link MarketConnectService}, {@link BusinessEntityService} and {@link CustomerLeadService} file.
      */
    public ngOnDestroy(): void {
      this.businessEntityService.cancelOnGoingHttpRequests();
      this.customerLeadService.cancelOnGoingHttpRequests();
      this.batchLoader?.markAsDestroyed();
      this.batchLoader?.reset();
    }
    /**
      * @method
      * @returns {void} This function does not return a value.
      * Description:
      * This method is used to Initializes various date values for different time ranges. Sets the values for the current day, yesterday, last week, last month, and last year.
      */
    public initDates(): any {
      let date = new Date();
      date.setDate(date.getDate() - 6);
      this.weekfromDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

      date = new Date();
      date.setDate(date.getDate() - 1);
      let yesterDay = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      this.yesterDayDate = (moment(yesterDay).format('YYYY-MM-DD')).toString();

      date = new Date();
      date.setDate(date.getDate() - 29);
      this.monthfromDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

      date = new Date();
      date.setDate(date.getDate() - 364);
      this.yearfromDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

      date = new Date();
      this.todayDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

      date = new Date(this.weekfromDate);
      date.setDate(date.getDate() - 7);
      this.lastWeekDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

      this.lastMonthEndDate = moment(new Date()).subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
      this.lastMonthStartDate = moment(new Date()).subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
      /*last year*/
      this.lastYearEndDate = moment(new Date()).subtract(1, 'year').endOf('year').format('YYYY-MM-DD');
      this.lastYearStartDate = moment(new Date()).subtract(1, 'year').startOf('year').format('YYYY-MM-DD');
    }
    /**
      * @method
      * @returns {void} This function does not return any value.
      * Description:
      * This method is used to Opens the specified element in fullscreen mode if the browser supports it.
      */
    public openFullScreen(): void {
      let element = document.getElementById('bluEyeCardConatiner') as HTMLElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      }
    }

    /**
      * @method
      * @returns {void} This function does not return any value.
      * Description:
      * This method is used to Closes the fullscreen mode if the current document supports it.
      */
    public closeFullScreen(): void {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      }
    }

     /**
      * @method
      * @param {string} type - The type of table or section to close.
      * @returns {void} This function does not return a value.
      * Description:
      * This method is used to Closes the specified table or section based on the provided type.
      */
     public closeTable(): void {
      this.showBluEyeSubscriberDetails = false;
    }

    /**
      * @method
      * @param {string} type - The type of report to generate and export.
      * @returns {void} A Promise that resolves when the Excel report is generated and exported, or when an error occurs.
      * Description:
      * This method is used to Generates and exports an Excel report based on the specified type (Hatcheries Report, Market Connect Report, or Farms Report).
      */
    public exportExcel(): void {
      const formatDate = (date: Date | string) => moment(date).format('YYYY-MM-DD');
      const currentDate = formatDate(new Date());

      const excelRequestBody: any = {
        include: 'businessID>businessType',
        pageSize: 5000,
        fromDate: currentDate,
        toDate: currentDate
      };

      switch (this.tablenoOfDays) {
        case 'oneweek':
          excelRequestBody.fromDate = formatDate(this.weekfromDate);
          break;
        case 'onemonth':
          excelRequestBody.fromDate = formatDate(this.monthfromDate);
          break;
        case 'oneyear':
          excelRequestBody.fromDate = formatDate(this.yearfromDate);
          break;
        case 'Custom':
          excelRequestBody.fromDate = formatDate(this.customBluEyeFromDate);
          excelRequestBody.toDate = formatDate(this.customBluEyeToDate);
          break;
      }

      try {
        const fileObj = this.customerLeadService.excelReportsDownload('BlueEyeSubscriptionsReport', excelRequestBody);
        fileObj.subscribe(fileblob => {
          if (fileblob) {
            this.excelService.saveAsExcelFile(fileblob, 'BluEye Subscribers Report');
          }
        });
      } catch (error) {
        this.toastr.error(error.error?.message || error)
      }

    }
}